angular.module('ui2.0Service').service('aeService',["$rootScope","$http","formService","$window","$uibModal", "$location","entityFactory",function (rootScope,http,formService,window,$modal,$location,entityFactory) {
    var self = this;
    this.allowedTypes = [
        {
            'name'      :   'Document',
            'allowed'   :   true,
            'extensions':   ['doc', 'docx', 'pdf', 'txt', 'html', 'htm', 'zip', 'eml' ,'msg','xlsx','xlsm','xlsb','xls'],
            'title'     :   'doc, docx, pdf, txt, html, htm, zip, eml, msg, xlsx, xlsm, xlsb, xls'
        },
        {
            'name'      :   'Image',
            'allowed'   :   true,
            'extensions':   ['png', 'jpeg', 'jpg', 'tiff', 'tif' ],
            'title'     :   'png, jpeg, jpg, tiff, tif'
        }

    ];
    this.aeLabels = {
        'notAllowed'        :   'File with extensions %s are not allowed',
        'folderOverWrite'   :   'Contents of folder will be overwritten by new folder',
        'selectFileType'    :   'Please select at-least 1 type of file',
    }
    this.isAll = function(arr,key,value){
        var linkNotEmpty = false;
        var notInItems = arr.filter(function(elm){
            if(elm[key]) {
                linkNotEmpty = true;
            }
            if(elm.hasOwnProperty('baseClauseText')){
                linkNotEmpty = true;
            }
            return (elm[key]!=value)
        });
        var retval = notInItems.length?false:true;
        return {retval:retval , linkNotEmpty:linkNotEmpty};
    }
    this.isNone = function(arr,key,value){
        var inItems = arr.filter(function(elm){return (elm[key]==value)});
        return inItems.length?false:true;
    }
    this.populateMasterPropertyData  = function(){
        this.isAeDocMiniPopup && (this.docPropData.projects.options = rootScope.aeDocPropMasterData.projects);
        this.docPropData.groups.options = rootScope.aeDocPropMasterData.groups;
        this.docPropData.doctags.options = rootScope.aeDocPropMasterData.tags;
        this.docPropData.tag1.options = rootScope.aeDocPropMasterData.tag1;
        this.docPropData.tag2.options = rootScope.aeDocPropMasterData.tag2;
        this.isAeDocMiniPopup && (this.docPropData.projects.values = self.getarrDel(this.docPropData.projectsVal, this.docPropData.projects.options ));
    }
    this.getarrDel = function(arg, options){
        if(!arg){
            return [];
        }
        if(!options) {
            var arr = arg.split("::");
            var arrSelected = arr.map(function (item) {
                var subArr = item.split(":;"),
                    resultObj = {id: subArr[1], name: subArr[0]};
                return resultObj
            })
            return arrSelected;
        } else {
            let optId = arg.split(":;")[1];
            return options.find((op)=>op.id == optId);
        }

    }
    this.populateDocumentPropertyData = function(){
        this.docPropData.groups.values = self.getarrDel(this.docPropData.groupsVal);
        this.docPropData.doctags.values = self.getarrDel(this.docPropData.doctagsVal);
        this.docPropData.tag1.values = self.getarrDel(this.docPropData.tag1Val);
        this.docPropData.tag2.values = self.getarrDel(this.docPropData.tag2Val);
    }
    this.extractIdsOnly = function(arr){
        return arr.map(function(elm){return elm.id})
    }
    this.openAeDropDowns = function(e, parentSelector, ddSelector){
        const pinStatus = angular.element('#filter').scope()?.getPinStatus();
        var elem = angular.element(e.currentTarget).closest(parentSelector);
        var offset =  elem.offset();
        var tableWidth = angular.element(".dataTables_scroll").width();
        var docList = elem.find(ddSelector) ;
        if(offset.left > (tableWidth / 2) ){
            if(pinStatus){
                docList.css('right', tableWidth - offset.left + 444)
            } else {
                docList.css('right', tableWidth - offset.left + 80)
            }
        } else{
            docList.css('left', offset.left + 30)
        }
        var container = $(".dataTables_scroll");
        var contHeight = container.height();
        var elemTop =offset.top - container.offset().top;
        var elemBottom = elemTop + docList.height() + 15 + 16; // 15 - slight distance from icon, 16 - padding
        var top = offset.top + 15;
        if(($(window).outerHeight() - elem.offset().top) < docList.outerHeight()){
            top = $(window).outerHeight() - docList.outerHeight() - 30;
        }
        docList.css('top',top)
        docList.show();
    }
    this.triggerReference = function(scope, docId){
        http.post('/autoextraction/trigger/reference/documentId',JSON.stringify({"documentId":docId}))
            .then(function(response){
                if(response.data.success){
                    Toaster.create(intl_msg[8272],{},function () {
                        scope.reloadListing();
                    });
                }
            })
    }
    this.aeWorkBench = function(searchParam,fromAEListing){
        if(fromAEListing && document.getElementById("aeListingWorkbench")){
            document.getElementById("aeListingWorkbench").style.pointerEvents = "none";
        }
        startLoader();
        let postData = {
            listId : Number(listId),
            filterMap: filterDataJson,
            contractId: contractId ? Number(contractId) : "",
            relationId: relationId ? Number(relationId) : "",
            vendorId: vendorId ? Number(vendorId) : "",
            'size' : 1000,
            entityIds: []
        };
        let scope = $("#data-ng-app").scope();
        if(searchParam){
            postData.searchName = searchParam;
        }
        http.post(scope.urlFactory.fetchAllIdsUrl(listId), JSON.stringify(postData))
            .then(function(res){
                stopLoader();
                if(res.data.entityIds && res.data.entityIds.length){
                    localStorage.setItem('allEntityIds', JSON.stringify(res.data.entityIds));
                    window.location.href =  appName + addtStamp(scope.urlFactory.getFormPageUrl("autoExtraction", "document", res.data.entityIds[0]))
                }
            })
    }

    this.getAllowedExtensions = function(){
        let allowedExtensions = [];
        self.allowedTypes.filter( (type) => type.allowed == true)
            .forEach((allowedType) =>{
                allowedExtensions = [...allowedExtensions, ...allowedType.extensions];
            });
        return allowedExtensions;
    }

    this.getAllowedFilesOnly = function(fileList){
        var allowedExtensions = this.getAllowedExtensions();
        fileList = Object.keys(fileList).filter((file)=>{
            if  (allowedExtensions.includes(fileList[file].name.split(".")[fileList[file].name.split(".").length - 1].toLowerCase())){
                return file;
            }
        }).map((f)=>{
            fileList[f].key = formService.getFileKey(fileList[f].name);
            return f;
        }).reduce((obj, key) => {
            obj[key] = fileList[key];
            return obj;
        }, {});
        return fileList;
    }
    this.manageFolderStructure = function(fileList){
        let firstFile = Object.values(fileList)[0];
        let tree = [];
        if(firstFile.webkitRelativePath == ""){
            Object.keys(fileList).forEach((f)=>{
                var treeObj = {
                    children: [],
                    extension: fileList[f].name.split('.')[fileList[f].name.split('.').length -1].toLowerCase(),
                    isAFolder: false,
                    path: "",
                    key : fileList[f].key
                }
                var nameArr = fileList[f].name.split('.');
                nameArr.splice(-1,1);
                treeObj.name = nameArr.join(".");
                tree.push(treeObj);
            })

        } else {
            tree = arrangeIntoTree(Object.keys(fileList).map( function(fileKey){
                return {
                    path: fileList[fileKey].webkitRelativePath.split("/"),
                    key: fileList[fileKey].key
                }
            }).reverse());
        }
        return tree;
    }
    let arrangeIntoTree = function(paths){
        var tree = [];

        for (var i = 0; i < paths.length; i++) {
            var path = paths[i].path;
            var currentLevel = tree;
            for (var j = 0; j < path.length; j++) {
                var part = path[j];
                var isFolder = j < path.length - 1;
                var existingPath = findWhere(currentLevel, 'name', part);
                if (existingPath) {
                    currentLevel = existingPath.children;
                } else {
                    var newPart = {
                        name: part,
                        extension: isFolder ? 'Folder-Open' : (part.split('.').length > 1 ? part.split('.')[part.split('.').length - 1].toLowerCase() : ''),
                        children: [],
                        isAFolder: isFolder,
                        path: isFolder ? '' : path.join('/'),
                        key : isFolder ? '' : paths[i].key
                    }
                    currentLevel.push(newPart);
                    currentLevel = newPart.children;
                }
            }
        }
        return tree;

        function findWhere(array, key, value) {
            var t = 0;
            while (t < array.length && array[t][key] !== value) { t++; };
            if (t < array.length) {
                return array[t]
            } else {
                return false;
            }
        }
    }
    this.addNewProp = function(val,propTypeId,propTypeName,scope){
        startLoader();
        var objToPost = {name:val};
        var endpoint = "/metadataautoextraction/create/"+propTypeId;
        let that = this;
        return http.post(endpoint,objToPost).then(function(res){
            if(res.data.id) {
                var newPropOption = {"id": res.data.id, "name": res.data.name};
                rootScope.aeDocPropMasterData && rootScope.aeDocPropMasterData[propTypeName].push(newPropOption);
                self.populateMasterPropertyData.call(scope);
                scope.addTagToList && scope.addTagToList(newPropOption);
            }else if(res.data.errorMessages && res.data.errorMessages.length){
                Toaster.create(res.data.errorMessages[0] || intl_msg[21077],{iconClass:"icon-Information_filled"});
            }else{
                Toaster.create(intl_msg[6462],{iconClass:"icon-Information_filled"});
            }
            stopLoader();
        },function(err){
            toggleServerErrorNotification(true);
            stopLoader();
        })
    }
    this.createCompareChanges = function(){
        this.updatedFields = JSON.parse(localStorage.getItem('updatedFields'))
        if(this.updatedFields) {
            this.updatedFields.forEach((f) => {
                if(!this.aeFieldLabelMapper[f.field]){
                    f.hide = true;
                    return;
                }
                var model = this.data;
                if(f.isDynamicField){
                    model = model.dynamicMetadata;
                } else if(this.aeFieldLabelMapper[f.field].isStakeHolder) {
                    model = model.stakeHolders.values;
                }
                if (Array.isArray(f.value)) {
                    f.myValue = (f.value.map((v) => {
                        return v.name
                    })).join(" ,");

                    f.currentValue = model[f.field].values ? (model[f.field].values.map((v) => {
                        return v.name
                    })).join(" ,") : '';
                }
                else{
                    f.myValue = f.value.name ? f.value.name : f.value;
                    let v = '';
                    if(model[f.field].hasOwnProperty('values')){
                        v = model[f.field]['values'];
                        if(v.hasOwnProperty('name')){
                            v = v.name;
                        }
                    } else if(model[f.field].hasOwnProperty('value')){
                        v = model[f.field]['value'];
                        if(v.hasOwnProperty('name')){
                            v = v.name;
                        }
                    }
                    f.currentValue = v;
                }
                f.action = 'Merge';
                f.label = this.aeFieldLabelMapper[f.field].label;
                f.id = this.aeFieldLabelMapper[f.field].id;
                f.actionTaken = false;
                if(f.currentValue == ''){
                    f.currentValue = '-'
                }
            });
            self.openAEMetaDataModal = $modal.open({
                templateUrl: rootScope.createHtmlUrl("ui2.0/aeDataMerge.html"),
                modal: true,
                keyboard: false,
                animation: true,
                backdrop: "static",
                windowClass: "clonepopup bulkOperation merge",
                scope: this
            });

            self.openAEMetaDataModal.close = function(){
                cancelMerge();
            }
        }
    }
    this.mergeFinally = function(){
        delete rootScope.updatedFieldsArray;
        localStorage.removeItem('updatedFields');
        rootScope.showMergeButton = false;
        rootScope.stopWorkflow = false;
        self.openAEMetaDataModal.dismiss('cancel');
    }
    this.copyAeData = function(field){
        if(field.isDynamicField){
            this.data.dynamicMetadata[field.field].values = field.value;
        } else if(this.aeFieldLabelMapper[field.field].isStakeHolder) {
            this.data.stakeHolders.values[field.field].values = field.value;
        }else{
            this.data[field.field].values = field.value;
        }
        field.action = 'merge';
        field.actionTaken = 'true';
        angular.element('.metadataPage .dynamicForm-ae #elem_'+field.id).closest('.coveringParent').addClass('merged-field');
    }
    this.retainAeData = function(field){
        field.action = 'retain';
        field.actionTaken = 'true';
    }
    this.cancelMerge = function(){
        const args = {
            popupType: 'confirm',
            str: 'Your changes will be discarded. Are you sure you want to continue?',
            heading: intl_msg[25772],
            yesCbFn: function () {
                $location.search('merge', null);
            },
            noCbFn: function () {
                return false;
            }
        }
        SirionUtils.openSirionDialogs(args);
    }

    this.computeListingBulkFilterContext = function(sc){
        var filteredData = JSON.parse(stringify_datatable_json(filterDataJson));
        if (SirionUtils.checkForSearchAndLocalFilters(sc) || SirionUtils.checkForPartialResetFilters(sc)) {
            var strFilterPost = SirionUtils.updateObjectWithData(JSON.stringify(filteredData, listJson.entityTypeId));
            filteredData = JSON.parse(strFilterPost);
        }
        filteredData = addRemoveSearchTextFromFilterMap(filteredData);
        var finalFilterDataJson = _.get(filteredData,"filterMap.filterJson") || {},
            searchNameFilter = _.get(filteredData,"filterMap.searchName") || null;
        if($(".react-filter-btn").length && !_.isEmpty(window.payload)) {
            finalFilterDataJson = _.get(window.payload, "filterMap.filterJson") || {};
        }
        return { finalFilterDataJson: finalFilterDataJson, searchNameFilter: searchNameFilter };
    };

    this.buildBulkUpdateRequestData = function(finalFilterDataJson, searchNameFilter, listIdOverride){
        var lid = (listIdOverride !== undefined && listIdOverride !== null && listIdOverride !== '') ? Number(listIdOverride) : Number(listId);
        return {
            listId: lid,
            filterMap: finalFilterDataJson,
            contractId: contractId ? Number(contractId) : "",
            relationId: relationId ? Number(relationId) : "",
            vendorId: vendorId ? Number(vendorId) : "",
            searchName: searchNameFilter
        };
    };

    this.allRowsSelected = function(obj,sc,bypassCheck){
        var ctx = self.computeListingBulkFilterContext(sc);
        var finalFilterDataJson = ctx.finalFilterDataJson,
            searchNameFilter = ctx.searchNameFilter;

        var listingSelectAllActive = !!(sc && (sc.allEnteriesSelectedFlag === true || sc.allSelected === true));
        var globalIsSelectAll = (typeof isSelectAll !== 'undefined' && isSelectAll);
        var selectAllPath = !!(rootScope.allSelected || bypassCheck || listingSelectAllActive || globalIsSelectAll || obj.selectAll);

        if(selectAllPath){
            obj.selectAll = true;
            sc && sc.extraFilterData && (finalFilterDataJson[sc.extraFilterData.filterId] = sc.extraFilterData);

            obj.bulkUpdateRequestData = self.buildBulkUpdateRequestData(finalFilterDataJson, searchNameFilter);

            if ($.urlParam("occurence")) {
                if(!obj.filterJson){
                    obj.filterJson = {
                        'filterMap' : {}
                    }
                }
                obj.filterJson.byPassFilters = true;
                if(!_.isEmpty(sc.todoListFilter)){
                    obj.filterJson.filterMap.customFilter = sc.todoListFilter.customFilter;
                }
                obj.filterJson.filterMap.bypassPreferredView = true;
            }
            if($.urlParam("requestId") && $.urlParam("type")){
                if(!obj.filterJson){
                    obj.filterJson = {};
                }
                obj.filterJson.bulkEditRequestId = parseInt($.urlParam("requestId"));
                obj.filterJson.isSuccess = $.urlParam("type") == "success" ? true : false;
            }
            return true;
        }
        return false;
    }

    this.getApplicableCategory = function(attrs){
        startLoader()
        const {scope,currentCategoryId,onlyResponse = false} = attrs || {};
        let projectId=!onlyResponse?attrs.currentProjectId:'';
        scope && (scope.popUpData.applicableCategories = []);
        return new Promise((resolve,reject) => {
            http.get('/metadataautoextraction/category/showCategory/'+projectId)
                .then(function(response){
                    stopLoader();
                    if(onlyResponse) {
                        resolve(response.data.response);
                        return;
                    }
                    if(response.data.success){
                        scope.popUpData.applicableCategories = response.data.response || [];
                        scope.popUpData.applicableCategories = scope.popUpData.applicableCategories && scope.popUpData.applicableCategories.sort((a, b) => a.name.localeCompare(b.name))
                        let categoryList = scope.popUpData.applicableCategories.filter(x=>x.id==currentCategoryId);
                        if(!categoryList ||  _.get(categoryList,'length')==0) {
                            scope.popUpData.newCategory = scope.popUpData.applicableCategories[0];
                        }else scope.popUpData.newCategory = categoryList[0];
                        resolve(response.data.response);
                    }else {
                        resolve(false);
                    }
                })
        })
    }
    this.getMetaDataFIelds = function (attrs) {
        const {scope,fieldId} = attrs;
        scope.popUpData.fields = [];
        if(scope.isAddMetaData){
            _.forEach(scope.itemData.fields,function (field) {
                field.name = field.label;
            })
            scope.popUpData.fields = _.size(scope.itemData.fields) ? scope.itemData.fields : [];
            scope.popUpData.fields = scope.popUpData.fields && scope.popUpData.fields.filter(a => a.name).sort((a, b) => a.name.localeCompare(b.name));
            scope.popUpData.selectedField = scope.popUpData.fields[0];
        }else {
            http.get('/metadataautoextraction/field/showField')
                .then(function(response){
                    if(response.data.success){
                        scope.popUpData.fields = response.data.response || [];
                        scope.popUpData.fields = scope.popUpData.fields && scope.popUpData.fields.sort((a, b) => a.name.localeCompare(b.name))
                        let fields = scope.popUpData.fields.filter(x=>x.id==fieldId);
                        if(_.get(fields,'length')==0) {
                            scope.popUpData.selectedField = scope.popUpData.fields[0];
                        }else scope.popUpData.selectedField = fields[0];
                    }
                })
        }
    }
    this.sendClauseFeedback = function(attrs){
        const {scope, itemData,popupData,actionType,fieldId,taggedText,tagList,selectedObj} = attrs;
        let fieldsFeedbackList = null,
            clauseFeedback = null
        if(scope.fromClause) {
            clauseFeedback = {
                previousCategoryId: itemData.id,
                newCategoryId: popupData.newCategory.id
            }
        }
        if(tagList.length == 0 && !scope.isAddMetaData)
            tagList.push(scope.itemData.extractedtext)
        if(tagList && tagList.length && !scope.fromClause && !scope.isAddMetaData) {
            fieldsFeedbackList =  [];
            _.forEach(tagList,(value) => {
                fieldsFeedbackList.push({
                    fieldId: fieldId,
                    fieldValue: value
                })
            })
        }
        var postData;
        if(scope.isAddMetaData){
            postData = {
                "listId": 493,
                "operation": 1,
                "textId": itemData.textId,
                "categoryId": itemData.categoryId,
                "documentId": itemData.documentId,
                "data": {
                    "fieldId": fieldId,
                    "previousValue": [],
                    "updatedValue": [itemData.text],
                },
                "coordinateInfo": {
                    "pageNumber": parseInt(scope.boundingRectsOfSpan[0]['pageNumber']),
                    "coordinateList" : scope.boundingRectsOfSpan[0]['coordinateList']
                }
            }
        } else {
            postData = [{
                documentId: itemData.documentid,
                textId: itemData.textId,
                text: itemData.text,
                extractionTypeId: 1001,
                fieldsFeedback: {
                    taggedText: taggedText,
                    dataJson: fieldsFeedbackList
                },
                clauseFeedback:clauseFeedback
            }];
        }
        let endpoint = scope.isAddMetaData ? "/metadataautoextraction/modifyExtractedData" : "/autoExtraction/extractionFeedback";
        startLoader();
        http.post(endpoint,postData)
            .then(function(response){
                stopLoader();
                const _attr = {
                    response,
                    customMessage:"Feedback saved succesfully",
                    closePopUp:scope.cancelHandler,
                    isAddMetaData: scope.isAddMetaData,/*scope.fromClause ? scope.cancelHandler : scope.resetTags*/
                    selectedField: selectedObj && selectedObj.name,
                    fieldId : fieldId,
                    isWorkFlowTriggered: rootScope.isWorkFlowTriggered,
                    activeNavTab: scope.activeNavTab,
                    getExtractedData: scope.getExtractedData,
                    metaDatatext: itemData.text,
                }
                responseHandler(_attr);
            })
    }

    this.getFieldCategoryMapping = function(scope, categoryId){
        if(!categoryId) {
            return;
        }
        http.get('/autoextraction/fetchFieldCategoryMappings/'+categoryId)
            .then(function(response){
                if(response.data.success){
                    scope.fields = response.data.response || [];
                    scope.popupMetaData.selectedField = scope.fields[0];
                }
            })
    }

    this.createUpdateDeleteMetadata = function(attrs){

        const {scope, itemData,popupData,actionType} = attrs;
        let previousValue = [],
            updatedValue = [];
        if(actionType==scope.ACTION_TYPE.INSERT) {
            previousValue = [];
            updatedValue = [popupData.updatedValue];
        }else if(actionType==scope.ACTION_TYPE.DELETE) {
            updatedValue = [];
        }
        let postData = {
            listId: scope.activeNavTab.id,
            operation: actionType,
            textId: itemData.textId,
            categoryId: itemData.categoryId,
            documentId: itemData.documentid,
            data: {
                fieldId: popupData.selectedField.id,
                previousValue: previousValue,
                updatedValue: updatedValue
            }
        }
        startLoader();
        http.post('/metadataautoextraction/modifyExtractedData',postData)
            .then(function(response){
                stopLoader();
                if(response.data.success){
                    scope.getExtractedData(true,true);
                }
                const _attr = {
                    response,
                    closePopUp:scope.cancelMetadataHandler
                }
                responseHandler(_attr);
            })
    }

    this.closeDisableAndPorting = function($scope){
        $scope.AEenablePorting = false;
        $scope.AEdisablePorting = false;
        $scope.AElistResetDD = false;
        $scope.aePorting.MDClause.enable=false;
        $scope.aePorting.MDClause.disable=false;
        $scope.aePorting.Obligation.enable=false;
        $scope.aePorting.Obligation.disable=false;
        $scope.deselectAllSelections();
    };

    this.porting = function($scope, flag){
        if(!BU.hasSelection()){
            Toaster.create(intl_msg[6443],{iconClass:"icon-Information_filled"});
            self.closeDisableAndPorting($scope);
            return;
        }
        startLoader();
        let url = '';
        let postobj ={};
        if(!flag){
            url = '/autoextraction/disable/porting';
            postobj = {
                'disableMDAndClausesPorting': $scope.aePorting.MDClause.disable,
                'disableObligationPorting': $scope.aePorting.Obligation.disable,
            }
        }else{
            url = '/autoextraction/doPorting';
            postobj = {
                'portMDAndClauses': $scope.aePorting.MDClause.enable,
                'portObligations': $scope.aePorting.Obligation.enable,
            }
        }
        const { selectAll, entityIds } = BU.buildPayload();
        postobj.selectAll = selectAll;
        if(selectAll){
            postobj['documentIds'] = [];
            this.allRowsSelected(postobj, $scope);
        } else {
            postobj['documentIds'] = entityIds;
        }
        entityFactory.getReactFilterData(postobj);
        http.post(url,postobj).then(function (response) {
            stopLoader();
            Toaster.create(intl_msg[24160]);
            self.closeDisableAndPorting($scope);
            $scope.reloadListing();
        },function(error){
            SirionUtils.openSirionDialogs({popupType: 'alert', str: intl_msg[6462], heading: intl_msg[24153]});
            stopLoader();
        });
    };
    this.createUpdateClauses = function(attrs){
        let url= '/autoextraction/update/clauses';
        const {scope,popupData,actionType} = attrs;
        let textId = null,
            aeCoordinate = null,
            closePopUp = scope.cancelNewClauseHandler;
        if(actionType != 1) {
            textId = popupData.textId ;
            if(typeof popupData.coordinates == 'string') {
                if(popupData.coordinates!='')
                    popupData.coordinates = JSON.parse(popupData.coordinates);
                else
                    popupData.coordinates = null;
            }
            aeCoordinate = Array.isArray(popupData.coordinates) ? popupData.coordinates[0] : popupData.coordinates;
            closePopUp = popupData.closeHandler || null;
        }
        let postData =  {
            text:popupData.newText,
            pageNumber: parseInt(popupData.pageNo),
            textId:textId,
            documentId: scope.entityId,
            categoryId:popupData.newCategory.id,
            operation:actionType,
            aeCoordinate: aeCoordinate
            // score:popupData.score,       ********* un-comment it if score is required at UI side ************
        }
        scope.clientLevelManualEdits && (url+=`?replaceclientlevel=true`);
        startLoader();
        http.post(url,postData)
            .then(function(response){
                stopLoader();
                let res = response.data.response;
                if(res.statusCode === 202){
                    scope.clientLevelManualEdits = res;
                    scope.clientLevelManualEdits.initials = globalFunc.getUserInitials(res.userName);
                    scope.clientLevelManualEdits.docId = sessionStorage.getItem('aeDocId');
                    return;
                }
                if(response.data.success){
                    scope.getExtractedData(true,true);
                }
                const _attr = {
                    response,
                    customMessage:"Data saved succesfully",
                    closePopUp
                }
                responseHandler(_attr);
            })
    }

    this.getInfoTextForDeviationScore = function(attrs){

        const {scope,textId} = attrs;
        startLoader();
        return new Promise((resolve,reject) => {
            http.get('/metadataautoextraction/fetchBaseText/'+textId)
                .then(function(response){
                    const _attr = {
                        response,
                        showToast:false,
                        shouldReturnData:true
                    }
                    const res = responseHandler(_attr);
                    stopLoader();
                    resolve(res);
                })
        })
    }
    this.aeResponseHandler = function (attrs) {
        responseHandler(attrs);
    }

    this.updateCData = function (aggregationResults) {
        window.sarc.channelBroadcast('refreshCData', {
            aggregationResults,
            fromAeDocShowPage : true
        });
    }

    const responseHandler = function (attrs) {
        let {response,customMessage="",closePopUp,showToast=true,shouldReturnData, selectedField, fieldId,isAddMetaData,getExtractedData,isWorkFlowTriggered, activeNavTab,metaDatatext} = attrs;
        if(response.data.success){
            let isMsgObjectTypeString = typeof _.get(response,"data.response") == 'string';
            let message = _.get(response,"data.response.message") || (isMsgObjectTypeString ? _.get(response,"data.response") : '' ) || customMessage
            showToast && Toaster.create(message);
            if(shouldReturnData && !closePopUp) {
                return response.data.response;
            }
            if(response.data.success && isAddMetaData && (typeof response.data.response.success === "undefined" || (typeof response.data.response.success !== "undefined" && response.data.response.success !== false))){
                if(isWorkFlowTriggered){
                    let aggregationResults = [{
                        fieldName: 'dyn'+fieldId,
                        values: metaDatatext,
                        fromAeGeneralTab: activeNavTab.id == 2 ? true : false ,
                        fieldId,
                    }];
                    self.updateCData(aggregationResults);
                }
                setTimeout(() => {
                    if(!isWorkFlowTriggered){
                        angular.element(document.querySelector('#Metadata')).triggerHandler('click');
                    }
                    setTimeout(() => {
                        if(!isWorkFlowTriggered || (isWorkFlowTriggered && activeNavTab.id == 433)){
                            getExtractedData(true,true,selectedField,fieldId,true);
                        }
                    },1000)
                });
            }
            closePopUp && closePopUp();
        }else if((_.get(response,"data.responseCode") == "422") && !response.data.success && isAddMetaData) {
            let message = _.get(response,"data.errors[0].message") || "Something went wrong";
            showToast && Toaster.create(message);
            closePopUp && closePopUp();
        }
        else if (_.get(response,"data.header.response.status") == "applicationError") {
            let message = _.get(response,"data.header.response.errorMessage") || "Something went wrong";
            SirionUtils.openSirionDialogs({popupType: 'alert', str: message, heading: intl_msg[24153]});
        }else if (_.get(response,'errorMessages.length')) {
            let arr = response.errorMessages;
            if(arr.length == 1){
                htmlError+=arr[0]["errorMessage"];
            }else{
                for(var i = 0;i<arr.length;i++){
                    htmlError+="<p><span>"+(i+1)+". </span><span>"+arr[i]["errorMessage"]+"</span></p>";
                }
            }
            SirionUtils.openSirionDialogs({popupType: 'alert', str: htmlError, heading: intl_msg[24153]});
        }
    }

     this.payloadToPost = function(param,highlightAllflag){
        const {activeNavTabId, entityId, entityTypeId, pagenum, textId, fieldId,highlightAllFlag,metaText} = param;
        if(highlightAllFlag){
            var dataToPost = {
                "searchCriteriaList":[
                    {
                        "key":"entityId",
                        "searchOperation":"EQUALITY",
                        "isAndOperation": true,
                        "arguments":[entityId]
                    },
                    {
                        "key":"entityTypeId",
                        "searchOperation":"EQUALITY",
                        "isAndOperation": true,
                        "arguments":[entityTypeId]
                    },
                    {
                        "key":"annotationSubCategory",
                        "searchOperation":"EQUALITY",
                        "isAndOperation": true,
                        "arguments":[activeNavTabId]
                    }
                ],
                "sortBy":"entityId",
                "sortDirection":"DESC"
            };
        } else if(activeNavTabId == 1){
            var dataToPost = {
                "searchCriteriaList":[
                    {
                        "key":"entityId",
                        "searchOperation":"EQUALITY",
                        "isAndOperation": true,
                        "arguments":[entityId]
                    },
                    {
                        "key":"entityTypeId",
                        "searchOperation":"EQUALITY",
                        "isAndOperation": true,
                        "arguments":[entityTypeId]
                    },
                    {
                        "searchOperation":"OR",
                        "isAndOperation": false,
                        "searchCriteriaList":[{
                            "key":"annotationSubCategory",
                            "searchOperation":"EQUALITY",
                            "arguments":[2]
                        },{
                            "searchOperation":"AND",
                            "searchCriteriaList":[{
                                "key":"annotationSubCategory",
                                "searchOperation":"EQUALITY",
                                "arguments":[1]
                            },
                                {
                                    "key":"dataMap.fieldId",
                                    "searchOperation":"EQUALITY",
                                    "arguments":[parseInt(fieldId)]
                                },
                                {
                                    "key": "text",
                                    "searchOperation": "EQUALITY",
                                    "arguments": [metaText]
                                }
                            ]
                        }]
                    },
                    {
                        "key":"startPageNumber",
                        "searchOperation":"EQUALITY",
                        "isAndOperation": true,
                        "arguments":[parseInt(pagenum)]
                    },
                    {
                        "key":"dataMap.textId",
                        "searchOperation":"EQUALITY",
                        "isAndOperation": true,
                        "arguments":[parseInt(textId)]
                    }
                ],
                "sortBy":"entityId",
                "sortDirection":"DESC"
            }
        }
        else if([2,3,4].indexOf(activeNavTabId) > -1){
             var dataToPost = {
                "searchCriteriaList":[
                    {
                        "key":"entityId",
                        "searchOperation":"EQUALITY",
                        "isAndOperation": true,
                        "arguments":[entityId]
                    },
                    {
                        "key":"entityTypeId",
                        "searchOperation":"EQUALITY",
                        "isAndOperation": true,
                        "arguments":[entityTypeId]
                    },
                    {
                        "key":"dataMap.textId",
                        "searchOperation":"EQUALITY",
                        "isAndOperation": true,
                        "arguments":[parseInt(textId)]
                    },
                    {
                        "key":"startPageNumber",
                        "searchOperation":"EQUALITY",
                        "isAndOperation": true,
                        "arguments":[parseInt(pagenum)]
                    },
                    {
                        "key":"annotationSubCategory",
                        "searchOperation":"EQUALITY",
                        "isAndOperation": true,
                        "arguments":[activeNavTabId]
                    }
                ],
                "sortBy":"entityId",
                "sortDirection":"DESC"
            };
        }
        return dataToPost;
    }

    this.annotationPayload = function(boundingRectsOfSpan,entityId,entityTypeId,clientId) {
        let dataToPost = {
            "entityId": entityId,
            "entityTypeId": entityTypeId,
            "clientId": clientId,
            "annotationSubCategory": {
                "id" : 2
            },
            "coordinateInfo": {
                "pageNumber":boundingRectsOfSpan &&  parseInt(boundingRectsOfSpan[0]['pageNumber']),
                "coordinateList" : boundingRectsOfSpan && boundingRectsOfSpan[0]['coordinateList']
            }
        };
        return dataToPost;
    }
}]);
